export default __webpack_public_path__ + "static/media/onnorokom_728_90.40be3948.gif";